// Klaviyo Added to Cart Script 
  var _learnq = _learnq || [];

  const addToCart = () => {
    _learnq.push(['track', 'Added to Cart', window.item])
  }

  setTimeout(() => {
    const addBtns = document.getElementsByClassName("PSButton")

    for (const addBtn of addBtns) {
        addBtn.addEventListener('click', addToCart, false)
    }
  }, 2000)
// End Klaviyo Added to Cart Script 